export function getMatchUrl(matchId: string): string {
  return `${window.location.origin}/match/${matchId}`;
}

function getShareText(teamA: string, teamB: string, status: "live" | "upcoming" | "completed"): string {
  const teams = `${teamA.trim()} vs ${teamB.trim()}`;
  if (status === "live") return `${teams} is LIVE on WatchWicket`;
  if (status === "completed") return `${teams} — View the result and scorecard on WatchWicket`;
  return `${teams} — Follow the match on WatchWicket`;
}

export async function shareMatch(
  matchId: string,
  teamA: string,
  teamB: string,
  status: "live" | "upcoming" | "completed"
): Promise<"shared" | "copied" | "failed"> {
  const url = getMatchUrl(matchId);
  const text = getShareText(teamA, teamB, status);
  const title = `${teamA.trim()} vs ${teamB.trim()} | WatchWicket`;

  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (e: any) {
      if (e.name === "AbortError") return "failed";
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
}
